import { Link } from 'react-router-dom'
import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'
import { industries } from '../../data/industries'

export function IndustriesOverview() {
  return (
    <section className="border-b border-ink/10 bg-bone py-24 md:py-32">
      <Container>
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <Eyebrow>Industries</Eyebrow>
            <h2 className="mt-6 max-w-xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
              Different industries. Different problems.
            </h2>
          </Reveal>
          <Reveal delay={100}>
            <CTA to="/industries" variant="ghost">
              Explore industries
            </CTA>
          </Reveal>
        </div>

        <div className="mt-16 flex flex-wrap gap-3">
          {industries.map((industry, i) => (
            <Reveal key={industry.slug} delay={i * 50}>
              <Link
                to={`/industries/${industry.slug}`}
                className="inline-flex items-center rounded-full border border-ink/15 bg-paper px-5 py-3 text-sm font-medium text-ink transition-colors hover:border-ink hover:text-signal"
              >
                {industry.name}
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}
